var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2e6a97e4ad14625d7204455cd2f6d6b3a316e77c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["culdesac-web-production@culdesac"]={id:"2e6a97e4ad14625d7204455cd2f6d6b3a316e77c"};
      